/* Wooden Touch site v3 - interactions ported 1:1 from the reference prototype,
   with the prototype's localStorage cart replaced by the real Shopify Cart AJAX API.
   Features: cart drawer (add / qty / subtotal / count), 360° angle switcher,
   live engraving preview. No frameworks. */
(function () {
  'use strict';

  var money = function (cents) {
    var v = cents / 100;
    var s = (Math.round(v * 100) % 100 === 0) ? String(Math.round(v)) : v.toFixed(2).replace('.', ',');
    return s + ' €';
  };

  /* ---------------- cart drawer ---------------- */
  var drawer = document.querySelector('[data-ws-cart-drawer]');
  var overlay = document.querySelector('[data-ws-cart-overlay]');
  var listEl = document.querySelector('[data-ws-cart-items]');
  var totalEl = document.querySelector('[data-ws-cart-total]');
  var countEls = document.querySelectorAll('[data-ws-cart-count]');
  var busy = false;

  function openCart() { document.documentElement.classList.add('ws-cart-open'); }
  function closeCart() { document.documentElement.classList.remove('ws-cart-open'); }

  /* Shopify CDN images accept a width param - request only thumbnail pixels */
  function thumbUrl(item) {
    var src = (item.featured_image && item.featured_image.url) || item.image;
    if (!src) return null;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }

  function renderShip(cart) {
    var ship = document.querySelector('[data-ws-cart-ship]');
    if (!ship) return;
    var threshold = parseInt(ship.getAttribute('data-threshold'), 10) || 0;
    if (threshold <= 0) { ship.hidden = true; return; }
    var rest = threshold - cart.items_subtotal_price;
    var fill = ship.querySelector('[data-ws-cart-ship-fill]');
    var label = ship.querySelector('[data-ws-cart-ship-label]');
    fill.style.width = Math.max(0, Math.min(100, cart.items_subtotal_price / threshold * 100)) + '%';
    ship.classList.toggle('is-done', rest <= 0);
    label.textContent = rest <= 0
      ? ship.getAttribute('data-done-text')
      : (ship.getAttribute('data-rest-text') || 'Noch %s').replace('%s', money(rest));
  }

  function renderCart(cart) {
    countEls.forEach(function (el) { el.textContent = cart.item_count; });
    if (totalEl) totalEl.textContent = money(cart.items_subtotal_price);
    var saveEl = document.querySelector('[data-ws-cart-savings]');
    if (saveEl) {
      var saved = cart.total_discount || 0;
      if (saved > 0) {
        saveEl.hidden = false;
        var sv = saveEl.querySelector('[data-ws-cart-savings-val]');
        if (sv) sv.textContent = money(saved);
      } else { saveEl.hidden = true; }
    }
    renderShip(cart);
    var upsellEl = document.querySelector('[data-ws-cart-upsell]');
    if (upsellEl) {
      var upsellId = parseInt(upsellEl.getAttribute('data-product-id'), 10);
      upsellEl.hidden = cart.items.some(function (item) { return item.product_id === upsellId; });
    }
    if (!listEl) return;
    listEl.innerHTML = '';
    if (!cart.items.length) {
      var empty = document.createElement('div');
      empty.className = 'ws-cart__empty';
      empty.innerHTML =
        '<div class="ws-cart__empty-ico" aria-hidden="true"><svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 7h12l-1 13H7L6 7Z"/><path d="M9 7V5.5A3 3 0 0 1 15 5.5V7"/></svg></div>' +
        '<div class="ws-cart__empty-title">' + (listEl.getAttribute('data-empty-text') || 'Ihr Warenkorb ist noch leer.') + '</div>' +
        '<a href="/collections/all" class="ws-cart__empty-cta">Kollektion entdecken</a>';
      listEl.appendChild(empty);
      var footEl = document.querySelector('[data-ws-cart-foot]');
      if (footEl) footEl.style.display = 'none';
      return;
    }
    var footShow = document.querySelector('[data-ws-cart-foot]');
    if (footShow) footShow.style.display = '';
    cart.items.forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'ws-cart__row';

      var media = document.createElement('div');
      media.className = 'ws-cart__thumb';
      var src = thumbUrl(item);
      if (src) {
        var img = document.createElement('img');
        img.src = src; img.alt = ''; img.width = 64; img.height = 64; img.loading = 'lazy';
        media.appendChild(img);
      }

      var info = document.createElement('div');
      info.className = 'ws-cart__info';
      var name = document.createElement('a');
      name.className = 'ws-cart__name';
      name.href = item.url;
      name.textContent = item.product_title;
      info.appendChild(name);
      /* variant title stays a quiet meta line */
      if (item.variant_title && item.variant_title !== 'Default Title') {
        var meta = document.createElement('div');
        meta.className = 'ws-cart__meta';
        meta.textContent = item.variant_title;
        info.appendChild(meta);
      }
      /* line-item properties (engraving name, figure, position …) become a
         highlighted "Personalisiert" chip - the brand's signature detail */
      var persoBits = [];
      Object.keys(item.properties || {}).forEach(function (k) {
        if (k.charAt(0) === '_' || !item.properties[k]) return;
        persoBits.push({ k: k, v: item.properties[k] });
      });
      if (persoBits.length) {
        var perso = document.createElement('div');
        perso.className = 'ws-cart__perso';
        var tag = document.createElement('span');
        tag.className = 'ws-cart__perso-tag';
        tag.innerHTML = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg> Personalisiert';
        perso.appendChild(tag);
        persoBits.forEach(function (b) {
          var line = document.createElement('span');
          line.className = 'ws-cart__perso-bit';
          line.innerHTML = '<em>' + b.k + ':</em> ' + b.v;
          perso.appendChild(line);
        });
        info.appendChild(perso);
      }

      var controls = document.createElement('div');
      controls.className = 'ws-cart__controls';
      var dec = document.createElement('button');
      dec.className = 'ws-cart__qtybtn'; dec.type = 'button'; dec.textContent = '−';
      dec.setAttribute('aria-label', 'Menge verringern');
      dec.addEventListener('click', function () { changeQty(item.key, item.quantity - 1); });
      var qty = document.createElement('span');
      qty.className = 'ws-cart__qty';
      qty.textContent = item.quantity;
      var inc = document.createElement('button');
      inc.className = 'ws-cart__qtybtn'; inc.type = 'button'; inc.textContent = '+';
      inc.setAttribute('aria-label', 'Menge erhöhen');
      inc.addEventListener('click', function () { changeQty(item.key, item.quantity + 1); });
      controls.appendChild(dec); controls.appendChild(qty); controls.appendChild(inc);
      var line = document.createElement('div');
      line.className = 'ws-cart__line';
      if (item.original_line_price > item.final_line_price) {
        line.innerHTML = '<span class="ws-cart__was">' + money(item.original_line_price) + '</span> ' + money(item.final_line_price);
      } else {
        line.textContent = money(item.final_line_price);
      }
      controls.appendChild(line);
      info.appendChild(controls);
      /* unit price hint once more than one is in the cart */
      if (item.quantity > 1) {
        var unit = document.createElement('div');
        unit.className = 'ws-cart__unit';
        unit.textContent = money(item.final_price) + ' pro Stück · auf Bestellung gefertigt';
        info.appendChild(unit);
      } else {
        var moq = document.createElement('div');
        moq.className = 'ws-cart__unit';
        moq.textContent = 'Auf Bestellung gefertigt';
        info.appendChild(moq);
      }

      var remove = document.createElement('button');
      remove.className = 'ws-cart__remove'; remove.type = 'button';
      remove.setAttribute('aria-label', item.product_title + ' entfernen');
      remove.innerHTML = '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" aria-hidden="true"><path d="M3 3l9 9M12 3l-9 9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
      remove.addEventListener('click', function () { changeQty(item.key, 0); });

      row.appendChild(media); row.appendChild(info); row.appendChild(remove);
      listEl.appendChild(row);
    });
  }

  function refreshCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  function changeQty(key, quantity) {
    if (busy) return; busy = true;
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    }).then(function (r) { return r.json(); })
      .then(renderCart)
      .finally(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-ws-add]');
    if (addBtn) {
      e.preventDefault();
      var variantId = parseInt(addBtn.getAttribute('data-ws-add'), 10);
      if (!variantId || busy) return;
      busy = true;
      addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return refreshCart();
      }).then(openCart)
        .catch(function () {})
        .finally(function () { busy = false; addBtn.disabled = false; });
      return;
    }
    if (e.target.closest('[data-ws-cart-open]')) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-ws-cart-close]')) { e.preventDefault(); closeCart(); return; }
  });
  if (overlay) overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
  if (drawer) refreshCart();

  /* ---------------- 360 viewer ---------------- */
  document.querySelectorAll('[data-ws-360]').forEach(function (root) {
    var tabs = root.querySelectorAll('.ws-360__tab');
    var views = root.querySelectorAll('.ws-360__view');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var angle = tab.getAttribute('data-angle');
        tabs.forEach(function (t) { t.classList.toggle('is-on', t === tab); });
        views.forEach(function (v) { v.classList.toggle('is-on', v.getAttribute('data-angle') === angle); });
      });
    });
  });

  /* ---------------- collection filter: age (single) + type (multi) ---------------- */
  document.querySelectorAll('[data-ws-filterbar]').forEach(function (bar) {
    var grid = document.querySelector('[data-ws-catalog]');
    if (!grid) return;
    var pills = bar.querySelectorAll('[data-ws-filter]');
    var cards = grid.querySelectorAll('[data-ws-item]');
    var wides = grid.querySelectorAll('[data-ws-wide]');
    var activeAge = 'alle';
    var selectedTypes = [];

    function ages(el) { return (el.getAttribute('data-ages') || '').split(',').map(function (s) { return s.trim(); }); }

    function apply() {
      cards.forEach(function (c) {
        var ageOk = activeAge === 'alle' || ages(c).indexOf(activeAge) >= 0;
        var typeOk = selectedTypes.length === 0 || selectedTypes.indexOf(c.getAttribute('data-type')) >= 0;
        c.style.display = ageOk && typeOk ? '' : 'none';
      });
      // editorial wide cards only make sense in the unfiltered view
      var clean = activeAge === 'alle' && selectedTypes.length === 0;
      wides.forEach(function (w) { w.style.display = clean ? '' : 'none'; });
    }

    /* age pills — single select */
    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        activeAge = p.getAttribute('data-ws-filter');
        pills.forEach(function (q) { q.classList.toggle('is-on', q === p); });
        apply();
      });
    });

    /* type panel — multi select */
    var tf = bar.querySelector('[data-ws-typefilter]');
    if (tf) {
      var toggle = tf.querySelector('[data-ws-type-toggle]');
      var panel = tf.querySelector('[data-ws-type-panel]');
      var countEl = tf.querySelector('[data-ws-type-count]');
      var clearBtn = tf.querySelector('[data-ws-type-clear]');
      var boxes = tf.querySelectorAll('[data-ws-type]');

      function openPanel(open) {
        panel.hidden = !open;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        tf.classList.toggle('is-open', open);
      }
      function syncTypes() {
        selectedTypes = [];
        boxes.forEach(function (b) { if (b.checked) selectedTypes.push(b.value); });
        if (countEl) {
          countEl.textContent = selectedTypes.length;
          countEl.hidden = selectedTypes.length === 0;
        }
        if (clearBtn) clearBtn.hidden = selectedTypes.length === 0;
        toggle.classList.toggle('is-active', selectedTypes.length > 0);
        // picking a type resets the age filter to "Alle"
        if (selectedTypes.length > 0 && activeAge !== 'alle') {
          activeAge = 'alle';
          pills.forEach(function (q) { q.classList.toggle('is-on', q.getAttribute('data-ws-filter') === 'alle'); });
        }
        apply();
      }

      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        openPanel(panel.hidden);
      });
      panel.addEventListener('click', function (e) { e.stopPropagation(); });
      boxes.forEach(function (b) { b.addEventListener('change', syncTypes); });
      if (clearBtn) clearBtn.addEventListener('click', function () {
        boxes.forEach(function (b) { b.checked = false; });
        syncTypes();
      });
      document.addEventListener('click', function () { openPanel(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') openPanel(false); });
    }

    apply();
  });

  /* ---------------- product page (views, options, qty, dynamic price, buy bar, accordions) ---------------- */
  var pdp = document.querySelector('[data-ws-pdp]');
  if (pdp) {
    var basePrice = parseInt(pdp.getAttribute('data-price'), 10) || 0; // cents
    var engravePrice = parseInt(pdp.getAttribute('data-engrave-price'), 10) || 0;
    var figurePrice = parseInt(pdp.getAttribute('data-figure-price'), 10) || 0;
    var qty = 1;
    var engraveOn = false, figureOn = false;
    var figureKind = '';
    var qtyEl = pdp.querySelector('[data-ws-qty]');
    var sumEls = document.querySelectorAll('[data-ws-total]');
    var summaryEl = document.querySelector('[data-ws-summary]');

    function unit() { return basePrice + (engraveOn ? engravePrice : 0) + (figureOn ? figurePrice : 0); }
    function update() {
      var t = money(unit() * qty);
      sumEls.forEach(function (el) { el.textContent = t; });
      if (qtyEl) qtyEl.textContent = qty;
      if (summaryEl) {
        var opt = [];
        if (engraveOn) opt.push('Namensgravur');
        if (figureOn) opt.push('Figur');
        var s = opt.length ? 'Mit ' + opt.join(' & ') : '';
        if (qty > 1) s = (s ? s + ' · ' : '') + qty + ' Stück';
        summaryEl.textContent = s;
      }
    }

    /* view switcher (images + optional 3D model view) */
    pdp.querySelectorAll('[data-ws-view-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-ws-view-btn');
        pdp.querySelectorAll('[data-ws-view-btn]').forEach(function (b) { b.classList.toggle('is-on', b === btn); });
        pdp.querySelectorAll('[data-ws-view]').forEach(function (v) { v.classList.toggle('is-on', v.getAttribute('data-ws-view') === key); });
      });
    });

    /* AR on the model-viewer, WebXR prioritised. Only WebXR renders AR with our HDR
       environment + exposure (Scene Viewer / Quick Look are system apps with no light
       control). We also brighten exposure WHILE in AR - the page look is untouched. */
    var mvWrap = pdp.querySelector('[data-ws-mv-wrap]');
    var mvEl = mvWrap ? mvWrap.querySelector('model-viewer') : null;
    if (mvEl && mvWrap) {
      var usdzSrc = mvWrap.getAttribute('data-usdz');
      mvEl.setAttribute('ar', '');
      mvEl.setAttribute('ar-modes', 'webxr scene-viewer quick-look');
      mvEl.setAttribute('ar-scale', 'fixed');
      mvEl.setAttribute('xr-environment', '');       // use the HDR env inside WebXR AR
      mvEl.setAttribute('shadow-intensity', '1');    // ground shadow inside WebXR AR
      // Statisches USDZ NICHT verwenden: es hat die Gravur-Platzhalter ("123/NAME")
      // eingebrannt. iOS erzeugt das USDZ dann live aus der (bereinigten) Szene.
      if (usdzSrc && !mvWrap.getAttribute('data-has-gravur')) mvEl.setAttribute('ios-src', usdzSrc);
      // Vor JEDEM AR-Start die Gravur-Platten säubern (opak, ohne Textur) - so ist
      // weder Transparenz noch Platzhalter-/Gravurtext im AR-Modell zu sehen.
      if (typeof mvEl.activateAR === 'function' && !mvEl._wtArWrapped) {
        mvEl._wtArWrapped = true;
        var _wtOrigAAR = mvEl.activateAR.bind(mvEl);
        mvEl.activateAR = function () { try { if (typeof mvEl._wtArClean === 'function') mvEl._wtArClean(); } catch (e) {} return _wtOrigAAR(); };
      }
      // AR (WebXR) exposure boost - richer than the page, page itself stays as set
      var pageExposure = parseFloat(mvEl.getAttribute('exposure')) || 1;
      var arExposure = Math.min(pageExposure * 1.6, 3).toFixed(2);
      mvEl.addEventListener('ar-status', function (e) {
        if (e.detail.status === 'session-started') {
          mvEl.setAttribute('exposure', arExposure);
        } else if (e.detail.status === 'not-presenting') {
          mvEl.setAttribute('exposure', pageExposure);
        }
      });
    }

    /* phone: "3D ansehen" toggles the model-viewer in place of the photo swiper */
    var gallery = pdp.querySelector('.ws-pdp__gallery');
    var toggle3d = pdp.querySelector('[data-ws-3d-toggle]');
    if (gallery && toggle3d) {
      var lbl = toggle3d.querySelector('[data-lbl]');
      toggle3d.addEventListener('click', function () {
        var on = gallery.classList.toggle('is-model');
        toggle3d.classList.toggle('is-on', on);
        // keep the desktop stacking switcher in sync too
        pdp.querySelectorAll('[data-ws-view]').forEach(function (v) {
          v.classList.toggle('is-on', on ? v.getAttribute('data-ws-view') === 'model' : v.getAttribute('data-ws-view') === 'v1');
        });
        if (lbl) lbl.textContent = on ? (toggle3d.getAttribute('data-lbl-off') || 'Fotos') : (toggle3d.getAttribute('data-lbl-on') || '3D');
      });
    }

    /* phone: "AR starten" - reveal the model-viewer, then launch AR in the same gesture */
    var arBtn = pdp.querySelector('[data-ws-ar]');
    if (arBtn && mvEl) {
      arBtn.addEventListener('click', function () {
        if (gallery && !gallery.classList.contains('is-model')) {
          gallery.classList.add('is-model');
          if (toggle3d) {
            toggle3d.classList.add('is-on');
            var l = toggle3d.querySelector('[data-lbl]');
            if (l) l.textContent = toggle3d.getAttribute('data-lbl-off') || 'Fotos';
          }
          pdp.querySelectorAll('[data-ws-view]').forEach(function (v) {
            v.classList.toggle('is-on', v.getAttribute('data-ws-view') === 'model');
          });
        }
        if (typeof mvEl.activateAR === 'function') {
          try { mvEl.activateAR(); } catch (e) {}
        }
      });
    }

    /* phone: swipe highlights the active thumbnail + keeps it in view; tapping a
       thumbnail scrolls the swipe stage to it. (Desktop image switching is handled
       by the data-ws-view-btn view switcher; scrollTo is a no-op on the grid stage.) */
    var stageEl = pdp.querySelector('.ws-pdp__stage');
    var thumbs = pdp.querySelectorAll('[data-ws-thumb]');
    if (stageEl && thumbs.length > 1) {
      var syncThumbs = function () {
        var w = stageEl.clientWidth || 1;
        var idx = Math.round(stageEl.scrollLeft / w);
        thumbs.forEach(function (t, i) { t.classList.toggle('is-on', i === idx); });
        var active = thumbs[idx];
        if (active && active.scrollIntoView) active.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      };
      stageEl.addEventListener('scroll', syncThumbs, { passive: true });
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          stageEl.scrollTo({ left: i * stageEl.clientWidth, behavior: 'smooth' });
        });
      });
    }

    /* colour variant swatches: swap gallery image + price + availability, and
       repoint data-variant so pdpAdd() carries the chosen colour to the cart */
    var addBtnEl = pdp.querySelector('[data-ws-pdp-add]');
    var soldLabel = pdp.getAttribute('data-sold-label') || 'Ausverkauft';
    var addLabel = addBtnEl ? addBtnEl.getAttribute('data-add-label') : '';
    var swatches = pdp.querySelectorAll('[data-ws-swatch]');
    var swValue = pdp.querySelector('[data-ws-sw-value]');
    if (swatches.length) {
      var selectSwatch = function (btn) {
        var price = parseInt(btn.getAttribute('data-price'), 10);
        var vid = btn.getAttribute('data-variant-id');
        var avail = btn.getAttribute('data-available') === 'true';
        var img = btn.getAttribute('data-img');
        var color = btn.getAttribute('data-color');

        swatches.forEach(function (s) {
          var on = s === btn;
          s.classList.toggle('is-on', on);
          s.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (swValue) swValue.textContent = color;
        if (!isNaN(price)) basePrice = price;
        pdp.setAttribute('data-variant', vid);

        /* swap the primary gallery photo to this colour */
        if (img) {
          var v1 = pdp.querySelector('[data-ws-view="v1"] img');
          if (v1) { v1.srcset = ''; v1.src = img; }
          pdp.querySelectorAll('[data-ws-view]').forEach(function (v) { v.classList.toggle('is-on', v.getAttribute('data-ws-view') === 'v1'); });
          pdp.querySelectorAll('[data-ws-view-btn]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-ws-view-btn') === 'v1'); });
        }

        /* availability reflects on the add button */
        if (addBtnEl) {
          addBtnEl.disabled = !avail;
          addBtnEl.style.opacity = avail ? '' : '0.5';
          addBtnEl.style.cursor = avail ? '' : 'not-allowed';
          var lbl = addBtnEl.querySelector('[data-ws-add-text]');
          if (lbl) lbl.textContent = avail ? addLabel : soldLabel;
        }

        /* shareable URL without a reload */
        if (history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', vid);
          history.replaceState({}, '', u);
        }
        update();
      };
      swatches.forEach(function (btn) { btn.addEventListener('click', function () { selectSwatch(btn); }); });
    }

    /* option toggles */
    pdp.querySelectorAll('[data-ws-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-ws-opt');
        var on;
        if (key === 'engrave') { engraveOn = !engraveOn; on = engraveOn; }
        else { figureOn = !figureOn; on = figureOn; }
        btn.classList.toggle('is-on', on);
        var panel = pdp.querySelector('[data-ws-opt-panel="' + key + '"]');
        if (panel) panel.classList.toggle('is-on', on);
        update();
      });
    });

    /* figure choice */
    pdp.querySelectorAll('[data-ws-fig]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        figureKind = btn.getAttribute('data-ws-fig');
        pdp.querySelectorAll('[data-ws-fig]').forEach(function (b) { b.classList.toggle('is-on', b === btn); });
      });
      if (btn.classList.contains('is-on')) figureKind = btn.getAttribute('data-ws-fig');
    });

    /* qty */
    pdp.querySelectorAll('[data-ws-qty-inc]').forEach(function (b) { b.addEventListener('click', function () { qty = Math.min(9, qty + 1); update(); }); });
    pdp.querySelectorAll('[data-ws-qty-dec]').forEach(function (b) { b.addEventListener('click', function () { qty = Math.max(1, qty - 1); update(); }); });

    /* add to cart: main item + option products as extra lines (with properties) */
    function pdpAdd() {
      var mainId = parseInt(pdp.getAttribute('data-variant'), 10);
      if (!mainId || busy) return;
      busy = true;
      /* The personalisation data lives ONCE, on the main line - that is the
         object being engraved. The surcharge lines only carry a hidden link
         back to it, so an order always says what to engrave onto what. */
      var props = {};
      var engraveInput = pdp.querySelector('[data-ws-engrave-input]');
      if (engraveOn) props['Gravurtext'] = (engraveInput && engraveInput.value.trim()) || 'Name folgt';
      if (figureOn && figureKind) props['Figur'] = figureKind;
      if (engraveOn || figureOn) {
        /* The position only exists where the 3D model has engraving plates.
           Without it the property used to be dropped silently and the order
           said nothing about placement - now it says "Standard". */
        props['Position'] = pdp.getAttribute('data-engrave-pos') || 'Standard';
      }

      var items = [{ id: mainId, quantity: qty, properties: props }];
      var engraveVar = parseInt(pdp.getAttribute('data-engrave-variant'), 10);
      var figureVar = parseInt(pdp.getAttribute('data-figure-variant'), 10);

      if ((engraveOn && engraveVar) || (figureOn && figureVar)) {
        /* Unique per add: it links the lines, and it keeps Shopify from
           merging two engravings of the same product into one line - which
           would lose which text belongs to which piece. */
        var uid = Math.random().toString(36).slice(2, 8) + Date.now().toString(36).slice(-4);
        props['_wt_uid'] = uid;
        if (engraveOn && engraveVar) {
          items.push({ id: engraveVar, quantity: qty, properties: { '_wt_ref': uid, '_wt_typ': 'namensgravur' } });
        }
        if (figureOn && figureVar) {
          items.push({ id: figureVar, quantity: qty, properties: { '_wt_ref': uid, '_wt_typ': 'figurengravur' } });
        }
      }
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) throw new Error('add'); return refreshCart(); })
        .then(openCart).catch(function () {})
        .finally(function () { busy = false; });
    }
    document.querySelectorAll('[data-ws-pdp-add]').forEach(function (b) { b.addEventListener('click', pdpAdd); });

    /* sticky buy bar after 500px */
    var buybar = document.querySelector('[data-ws-buybar]');
    if (buybar) {
      var onScroll = function () { buybar.classList.toggle('is-on', window.scrollY > 500); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    update();
  }

  /* ---------------- accordions ---------------- */
  document.querySelectorAll('.ws-acc').forEach(function (acc) {
    var head = acc.querySelector('.ws-acc__head');
    if (head) head.addEventListener('click', function () { acc.classList.toggle('is-open'); });
  });

  /* ---------------- hero slider ----------------
     Exit choreography lives in CSS; this only sequences the class changes and
     waits out the longest exit transition (visual, which starts 140ms late). */
  document.querySelectorAll('[data-ws-hero]').forEach(function (root) {
    var slides = [].slice.call(root.querySelectorAll('[data-ws-hero-slide]'));
    if (slides.length < 2) return;

    var section = root.closest('.ws-hero-sec') || root.parentNode;
    var dots = [].slice.call(section.querySelectorAll('[data-ws-hero-dot]'));
    var counter = section.querySelector('[data-ws-hero-current]');
    var autoplay = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var EXIT = reduce ? 0 : 660;   // copy .5s + visual .14s delay + buffer
    var idx = 0, busy = false, timer = null;

    function paintDots() {
      dots.forEach(function (d, i) {
        var on = i === idx;
        d.classList.toggle('is-on', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
        d.classList.remove('is-timing', 'is-timing-reset');
      });
      if (counter) counter.textContent = idx + 1;
      // let the active bar fill over the autoplay interval as a progress hint
      if (autoplay && !reduce && dots[idx]) {
        var bar = dots[idx];
        bar.style.setProperty('--ws-hero-dur', autoplay + 's');
        bar.classList.add('is-timing-reset');
        requestAnimationFrame(function () {
          bar.classList.remove('is-timing-reset');
          requestAnimationFrame(function () { bar.classList.add('is-timing'); });
        });
      }
    }

    function focusable(slide, enabled) {
      slide.querySelectorAll('a').forEach(function (a) {
        if (enabled) a.removeAttribute('tabindex');
        else a.setAttribute('tabindex', '-1');
      });
      slide.setAttribute('aria-hidden', enabled ? 'false' : 'true');
    }

    function go(next) {
      if (busy || next === idx || !slides[next]) return;
      busy = true;
      var cur = slides[idx];
      var nxt = slides[next];

      cur.classList.add('is-leaving');
      focusable(cur, false);

      setTimeout(function () {
        cur.classList.remove('is-active', 'is-leaving');
        nxt.classList.add('is-active', 'is-entering');
        focusable(nxt, true);
        // one frame with is-entering so the fade actually runs from 0
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { nxt.classList.remove('is-entering'); });
        });
        idx = next;
        paintDots();
        setTimeout(function () { busy = false; }, reduce ? 0 : 560);
      }, EXIT);
    }

    function next() { go((idx + 1) % slides.length); }
    function start() { if (autoplay && !timer) timer = setInterval(next, autoplay * 1000); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        go(parseInt(d.getAttribute('data-ws-hero-dot'), 10));
        restart();
      });
    });

    // swipe on touch devices
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) { dx < 0 ? next() : go((idx - 1 + slides.length) % slides.length); restart(); }
      x0 = null;
    }, { passive: true });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    slides.forEach(function (s, i) { focusable(s, i === 0); });
    paintDots();
    start();
  });

  /* ---------------- shipping zones + live delivery estimate ---------------- */
  document.querySelectorAll('[data-ws-ship]').forEach(function (root) {
    var zones = root.querySelectorAll('[data-ws-zone]');
    if (!zones.length) return;
    var production = parseInt(root.getAttribute('data-production'), 10) || 0;
    var costEl = root.querySelector('[data-ws-ship-cost]');
    var freeEl = root.querySelector('[data-ws-ship-free]');
    var daysEl = root.querySelector('[data-ws-ship-days]');
    var noteEl = root.querySelector('[data-ws-ship-note]');
    var etaEl = root.querySelector('[data-ws-ship-eta]');
    var progress = root.querySelector('[data-ws-ship-progress]');
    var fillEl = root.querySelector('[data-ws-ship-fill]');
    var remainEl = root.querySelector('[data-ws-ship-remaining]');

    // add N business days to a date (skips Sat/Sun)
    function addBusinessDays(from, n) {
      var d = new Date(from.getTime());
      var added = 0;
      while (added < n) {
        d.setDate(d.getDate() + 1);
        var day = d.getDay();
        if (day !== 0 && day !== 6) added++;
      }
      return d;
    }
    var fmt = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: 'numeric', month: 'short' });
    var eur = function (cents) {
      return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    };

    function apply(btn) {
      var price = parseInt(btn.getAttribute('data-price'), 10) || 0;
      var freeFrom = parseInt(btn.getAttribute('data-free-from'), 10) || 0;
      var min = parseInt(btn.getAttribute('data-min'), 10) || 0;
      var max = parseInt(btn.getAttribute('data-max'), 10) || 0;
      var note = btn.getAttribute('data-note') || '';

      zones.forEach(function (z) {
        var on = z === btn;
        z.classList.toggle('is-on', on);
        z.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      if (costEl) costEl.textContent = price === 0 ? 'Kostenlos' : eur(price);
      if (freeEl) {
        freeEl.textContent = price === 0
          ? 'für jede Bestellung'
          : (freeFrom > 0 ? 'kostenlos ab ' + eur(freeFrom * 100) : 'zzgl. Zoll und Einfuhrsteuer');
      }
      if (daysEl) daysEl.textContent = (production + min) + '–' + (production + max) + ' Werktage';
      if (noteEl) noteEl.textContent = note;

      if (etaEl) {
        var today = new Date();
        var from = addBusinessDays(today, production + min);
        var to = addBusinessDays(today, production + max);
        etaEl.textContent = fmt.format(from) + ' – ' + fmt.format(to);
      }

      // free-shipping progress against the real cart total
      if (progress && fillEl) {
        var total = parseInt(progress.getAttribute('data-cart-total'), 10) || 0;
        var threshold = freeFrom * 100;
        if (price === 0 || threshold <= 0) {
          progress.style.display = 'none';
        } else {
          progress.style.display = '';
          var pct = Math.min(100, Math.round((total / threshold) * 100));
          fillEl.style.width = pct + '%';
          if (remainEl) {
            remainEl.textContent = total >= threshold
              ? 'Versandkostenfrei erreicht.'
              : 'Noch ' + eur(threshold - total) + ' bis zum kostenlosen Versand.';
          }
        }
      }
    }

    zones.forEach(function (z) { z.addEventListener('click', function () { apply(z); }); });
    apply(root.querySelector('[data-ws-zone].is-on') || zones[0]);
  });

  /* ---------------- DHL tracking hand-off ---------------- */
  document.querySelectorAll('[data-ws-track]').forEach(function (root) {
    var input = root.querySelector('[data-ws-track-input]');
    var go = root.querySelector('[data-ws-track-go]');
    var hint = root.querySelector('[data-ws-track-hint]');
    var base = root.getAttribute('data-url') || '';
    var defaultHint = hint ? hint.textContent : '';
    if (!input || !go) return;

    function submit() {
      var code = (input.value || '').replace(/\s+/g, '');
      if (code.length < 8) {
        if (hint) { hint.textContent = 'Bitte geben Sie eine vollständige Sendungsnummer ein.'; hint.classList.add('is-error'); }
        input.focus();
        return;
      }
      if (hint) { hint.textContent = defaultHint; hint.classList.remove('is-error'); }
      window.open(base + encodeURIComponent(code), '_blank', 'noopener');
    }
    go.addEventListener('click', submit);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submit(); } });
  });

  /* ---------------- contact status pill (open/closed by local time) ---------------- */
  document.querySelectorAll('[data-ws-status]').forEach(function (el) {
    var d = new Date();
    var open = d.getDay() >= 1 && d.getDay() <= 5 && d.getHours() >= 9 && d.getHours() < 17;
    var text = el.getAttribute(open ? 'data-open' : 'data-closed');
    if (text) el.textContent = text;
  });

  /* ---------------- engraving live preview ---------------- */
  document.querySelectorAll('[data-ws-engrave]').forEach(function (root) {
    var input = root.querySelector('[data-ws-engrave-input]');
    var out = root.querySelector('[data-ws-engrave-out]');
    if (!input || !out) return;
    var fallback = out.getAttribute('data-default') || 'Emil';
    input.addEventListener('input', function () {
      out.textContent = input.value.trim() || fallback;
    });
  });

  /* ---------------- 3D model: blend into the stage + auto-activate ----------------
     Shopify's model_viewer_tag ships a white poster JPEG and waits for a tap
     ("reveal: interaction"). On the dark 360 stage that reads as a white window,
     and the tap step feels broken. So: drop the poster immediately (the stage
     gradient shows through the transparent canvas) and dismiss the poster as
     soon as the stage scrolls into view - the model is drag-rotatable at once. */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('.ws-360__model, .ws-pdp__view[data-ws-view="model"]').forEach(function (wrap) {
    var dark = wrap.classList.contains('ws-360__model');

    function arm(mv) {
      if (mv.dataset.wsArmed) return;
      mv.dataset.wsArmed = '1';
      if (dark) {
        /* Exakt wie der funktionierende Personalisierungs-Block: Shopifys Tag NICHT
           anfassen (kein Poster-Eingriff, kein IntersectionObserver - genau das hat
           das Modell auf dem Handy nie erscheinen lassen), nur Steuerung aktivieren. */
        mv.setAttribute('camera-controls', '');
        if (!reduceMotion) { mv.setAttribute('auto-rotate', ''); mv.setAttribute('auto-rotate-delay', '600'); }
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.disconnect();
          var go = function () {
            if (typeof mv.dismissPoster === 'function') mv.dismissPoster();
            else mv.setAttribute('reveal', 'auto');
            if (!reduceMotion && !mv.dataset.engraveActive) { mv.setAttribute('auto-rotate', ''); mv.setAttribute('auto-rotate-delay', '600'); }
          };
          if (window.customElements && customElements.get('model-viewer')) go();
          else if (window.customElements) customElements.whenDefined('model-viewer').then(go);
        });
      }, { threshold: 0.35 });
      io.observe(mv);
    }

    /* AR fuer die 360-Sektion: model-viewer startet AR selbst (wie auf der PDP).
       Der Button bleibt versteckt, solange das Geraet kein AR kann - kein toter Knopf. */
    /* AR per nativem Plattform-Link: iOS Quick Look (USDZ) bzw. Android Scene Viewer.
       Das laeuft zuverlaessig aus der Nutzergeste - anders als activateAR(), das
       Safari oft blockiert. Ohne AR-faehiges Geraet: Knopf aus, Hinweis an. */
    function armAr(mv) {
      var btn = document.querySelector('[data-ws-360-ar]');
      if (!btn || btn.dataset.wsArReady) return;
      btn.dataset.wsArReady = '1';
      var note = document.querySelector('[data-ws-360-arnote]');
      var ua = navigator.userAgent || '';
      var isIOS = /iPad|iPhone|iPod/.test(ua) || (ua.indexOf('Mac') > -1 && navigator.maxTouchPoints > 1);
      var isAndroid = /Android/.test(ua);
      var usdz = btn.getAttribute('data-usdz');
      var glb = btn.getAttribute('data-glb');

      if (isIOS && usdz) {
        btn.setAttribute('rel', 'ar');
        btn.setAttribute('href', usdz);
        /* Apple verlangt ein <img>-Kind, sonst startet Quick Look nicht */
        if (!btn.querySelector('img')) {
          var im = document.createElement('img');
          im.alt = ''; im.width = 1; im.height = 1;
          im.style.cssText = 'width:1px;height:1px;opacity:0;position:absolute;pointer-events:none;';
          im.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
          btn.appendChild(im);
        }
        btn.hidden = false; if (note) note.hidden = true;
      } else if (isAndroid && glb) {
        var abs = new URL(glb, window.location.href).href;
        btn.setAttribute('href',
          'intent://arvr.google.com/scene-viewer/1.0?file=' + encodeURIComponent(abs) +
          '&mode=ar_preferred&title=' + encodeURIComponent(btn.getAttribute('data-title') || '') +
          '#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;' +
          'S.browser_fallback_url=' + encodeURIComponent(window.location.href) + ';end;');
        btn.hidden = false; if (note) note.hidden = true;
      } else {
        /* Desktop: kein AR - Knopf ausblenden, Hinweis zeigen */
        btn.hidden = true; if (note) note.hidden = false;
      }

      /* QR-Code-Einstieg: ".../?ar=1" startet AR sofort. Ein QR wird von iPhone UND
         Android gescannt - eine rohe .usdz- bzw. intent://-URL koennte immer nur
         eine der beiden Seiten bedienen. Die Navigation laeuft beim Laden, das
         erlaubt Safari (anders als einen Klick ohne Geste). */
      try {
        if (/[?&]ar=1(&|$)/.test(window.location.search) && !btn.hidden) {
          var target = btn.getAttribute('href');
          if (target && target !== '#') { window.location.href = target; }
        }
      } catch (e) {}
    }

    var mv = wrap.querySelector('model-viewer');
    if (mv) { arm(mv); if (dark) armAr(mv); }
    else {
      /* Shopify's UI script may re-wrap the element after load */
      new MutationObserver(function (m, obs) {
        var el = wrap.querySelector('model-viewer');
        if (el) { obs.disconnect(); arm(el); }
      }).observe(wrap, { childList: true, subtree: true });
    }
  });

  /* ---------------- engraving figure picker ---------------- */
  /* The buttons carried data-ws-fig but nothing listened, so picking a figure
     did nothing at all. Selecting one now mirrors its icon into the wood
     preview; clicking the active one again clears it (a figure is optional). */
  document.querySelectorAll('[data-ws-engrave]').forEach(function (root) {
    var figs = root.querySelectorAll('[data-ws-fig]');
    var slot = root.querySelector('[data-ws-fig-out]');
    if (!figs.length || !slot) return;

    function select(btn) {
      figs.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var icon = btn && btn.querySelector('[data-ws-fig-icon]');
      slot.innerHTML = icon ? icon.innerHTML : '';
      slot.classList.toggle('is-on', !!icon);
    }

    figs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        select(btn.classList.contains('is-on') ? null : btn);
      });
    });

    select(root.querySelector('[data-ws-fig].is-on'));
  });

  /* ---------------- video reel: 9:16 clips, thought through as a visitor would expect:
     1) AUTO montage - each clip plays 1 second, one after another, looping (muted).
     2) Tap a clip - the montage stops and that clip plays IN FULL, with sound.
     3) Tap another clip - that one plays instead.
     4) A full clip ends and nothing was tapped - the montage carries on from the next. */
  document.querySelectorAll('[data-ws-reel]').forEach(function (reel) {
    var cards = [].slice.call(reel.querySelectorAll('[data-ws-reel-card]'));
    if (!cards.length) return;
    var wrap = reel.closest('[data-ws-reel-wrap]');
    var vids = cards.map(function (c) { return c.querySelector('[data-ws-reel-video]'); });
    var N = cards.length;
    var STEP_MS = 1600;                                  // a touch over 1 second per clip in the montage
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var idx = 0, mode = 'idle', timer = null, inView = false;   // mode: idle | auto | focus

    function firstVid(from) { for (var k = 0; k < N; k++) { var j = (from + k) % N; if (vids[j]) return j; } return -1; }
    function progress(i, frac) { var bar = cards[i] && cards[i].querySelector('.ws-reel__prog span'); if (bar) bar.style.width = (Math.max(0, Math.min(1, frac || 0)) * 100) + '%'; }
    function mark(i, isFocus) { cards.forEach(function (c, j) { c.classList.toggle('is-active', j === i); c.classList.toggle('is-playing', j === i); c.classList.toggle('is-focus', !!isFocus && j === i); }); }
    function silenceOthers(i) { vids.forEach(function (v, j) { if (v && j !== i) { v.pause(); v.muted = true; v.controls = false; } }); }
    function ensureVisible(i) {
      var c = cards[i]; if (!c) return;
      var cl = c.offsetLeft, cr = cl + c.offsetWidth, sl = reel.scrollLeft, sr = sl + reel.clientWidth;
      if (cl < sl - 1 || cr > sr + 1) {
        reel._autoScroll = true;
        c.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
        clearTimeout(reel._autoScrollT); reel._autoScrollT = setTimeout(function () { reel._autoScroll = false; }, 550);
      }
    }

    /* ---- 1) AUTO montage: 1s per clip, in order, muted ---- */
    function playAuto(i) {
      i = firstVid(i); if (i < 0) return;
      mode = 'auto'; idx = i; clearTimeout(timer);
      silenceOthers(i); mark(i, false);
      var v = vids[i]; v.muted = true; v.controls = false; v.loop = true;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
      ensureVisible(i);
      timer = setTimeout(function () { if (mode === 'auto') playAuto((idx + 1) % N); }, STEP_MS);
    }
    function startAuto() { if (mode === 'focus' || !inView || reduce) return; playAuto(idx); }

    /* ---- 2 & 3) FOCUS: a tapped clip plays fully with sound; auto is stopped ---- */
    function focusClip(i) {
      if (!vids[i]) return;
      mode = 'focus'; idx = i; clearTimeout(timer);
      silenceOthers(i); mark(i, true);
      var v = vids[i]; v.muted = false; v.volume = 0.5; v.controls = true; v.loop = false;
      try { v.currentTime = 0; } catch (e) {}
      var p = v.play(); if (p && p.catch) p.catch(function () {});
      ensureVisible(i);
    }
    /* ---- 4) leave focus and resume the montage ---- */
    function endFocus(fromNext) {
      var v = vids[idx]; if (v) { v.pause(); v.muted = true; v.controls = false; v.loop = true; }
      if (cards[idx]) cards[idx].classList.remove('is-focus');
      mode = 'auto';
      if (inView && !reduce) playAuto(fromNext ? (idx + 1) % N : idx); else mode = 'idle';
    }

    cards.forEach(function (card, i) {
      var v = vids[i];
      if (v) {
        v.addEventListener('timeupdate', function () { if (i === idx && v.duration) progress(i, (v.currentTime % v.duration) / v.duration); });
        v.addEventListener('ended', function () { if (mode === 'focus' && i === idx) endFocus(true); });   // point 4
      }
      var closeB = card.querySelector('[data-ws-reel-close]');
      if (closeB) closeB.addEventListener('click', function (e) { e.stopPropagation(); if (mode === 'focus') endFocus(true); });
      card.addEventListener('click', function (e) {
        if (reel._dragged) return;
        if (e.target.closest('a')) return;                       // name link -> product
        if (e.target.closest('[data-ws-reel-close]')) return;
        if (mode === 'focus' && idx === i) return;               // already focused: native controls
        if (!vids[i]) return;
        focusClip(i);                                            // points 2 & 3
      });
    });

    /* start / pause with page visibility */
    if (!reduce && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          inView = e.isIntersecting;
          if (!inView) { clearTimeout(timer); vids.forEach(function (v) { if (v) v.pause(); }); cards.forEach(function (c) { c.classList.remove('is-playing'); }); }
          else if (mode === 'focus') { var v = vids[idx]; if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
          else startAuto();
        });
      }, { threshold: 0.2 }).observe(reel);
    } else if (!reduce) { inView = true; startAuto(); }

    /* Only a genuine user gesture (swipe / wheel / drag / arrow) may re-sync the
       montage to the centred clip. Programmatic centering (ensureVisible) must NOT,
       or auto-scroll feeds back into the scroll handler and the montage sticks. */
    var lastUser = 0;
    function markUser() { lastUser = Date.now(); }
    function userDriven() { return (Date.now() - lastUser) < 700; }
    ['wheel', 'touchstart', 'touchmove'].forEach(function (ev) { reel.addEventListener(ev, markUser, { passive: true }); });

    /* arrows */
    function step() { return Math.max(reel.clientWidth * 0.85, 240); }
    function updateNav() {
      if (!wrap) return;
      var prev = wrap.querySelector('[data-ws-reel-prev]'), next = wrap.querySelector('[data-ws-reel-next]');
      var max = reel.scrollWidth - reel.clientWidth - 2;
      if (prev) prev.disabled = reel.scrollLeft <= 2;
      if (next) next.disabled = reel.scrollLeft >= max;
    }
    if (wrap) {
      var pB = wrap.querySelector('[data-ws-reel-prev]'), nB = wrap.querySelector('[data-ws-reel-next]');
      if (pB) pB.addEventListener('click', function () { markUser(); if (mode === 'focus') endFocus(false); reel.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (nB) nB.addEventListener('click', function () { markUser(); if (mode === 'focus') endFocus(false); reel.scrollBy({ left: step(), behavior: 'smooth' }); });
    }

    /* manual scroll: sync arrows; leave focus; let the montage follow the visitor's view */
    var sc;
    reel.addEventListener('scroll', function () {
      updateNav();
      clearTimeout(sc);
      sc = setTimeout(function () {
        if (!userDriven()) return;                               // ignore our own centering scrolls
        if (mode === 'focus') { endFocus(false); return; }       // user scrolled away -> stop watching
        if (mode !== 'auto') return;
        var center = reel.scrollLeft + reel.clientWidth / 2, best = idx, bd = Infinity;
        cards.forEach(function (c, i) { if (vids[i]) { var cc = c.offsetLeft + c.offsetWidth / 2, d = Math.abs(cc - center); if (d < bd) { bd = d; best = i; } } });
        if (best !== idx) playAuto(best);                        // continue montage from where the visitor looks
      }, 160);
    }, { passive: true });
    updateNav();
    window.addEventListener('resize', updateNav);

    /* drag-to-scroll (desktop mouse; touch scrolls natively) */
    var down = false, startX = 0, startScroll = 0;
    reel.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; startX = e.clientX; startScroll = reel.scrollLeft; reel._dragged = false; });
    reel.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - startX; if (Math.abs(dx) > 4) { reel.classList.add('is-dragging'); reel._dragged = true; markUser(); } reel.scrollLeft = startScroll - dx; });
    function endDrag() { down = false; reel.classList.remove('is-dragging'); setTimeout(function () { reel._dragged = false; }, 40); }
    reel.addEventListener('pointerup', endDrag);
    reel.addEventListener('pointerleave', endDrag);
    reel.addEventListener('pointercancel', endDrag);
  });
})();

/* ============================================================
   3D-Gravur direkt in der Produktgalerie
   - Kamera/Ziel je WT_Gravur-Platte werden zur LAUFZEIT aus der GLB-Geometrie
     berechnet (kein Hardcode) -> funktioniert fuer JEDES Produkt mit Platten.
   - KEINE Textur-Rotation; Textur landet auf dem richtigen Material der Stelle.
   - Text + Figur fuellen die Platte fast randfuellend.
   ============================================================ */
(function () {
  /* ---- GLB im Browser parsen, je Platte camera-orbit + camera-target berechnen ---- */
  function computePresets(url, cb) {
    fetch(url).then(function (r) { return r.arrayBuffer(); }).then(function (buf) {
      try {
        var dv = new DataView(buf);
        var jsonLen = dv.getUint32(12, true);
        var gltf = JSON.parse(new TextDecoder().decode(new Uint8Array(buf, 20, jsonLen)));
        var binBase = 20 + jsonLen + 8;                       // Start der BIN-Daten in buf
        var NC = { SCALAR:1, VEC2:2, VEC3:3, VEC4:4 };
        function acc(i) {
          var a = gltf.accessors[i], bv = gltf.bufferViews[a.bufferView];
          var comps = NC[a.type], stride = bv.byteStride || comps*4;
          var base = binBase + (bv.byteOffset||0) + (a.byteOffset||0), out = [];
          for (var k=0;k<a.count;k++){ var o=base+k*stride, v=[]; for(var c=0;c<comps;c++) v.push(dv.getFloat32(o+c*4,true)); out.push(v); }
          return out;
        }
        function mmul(A,B){ var R=new Array(16); for(var c=0;c<4;c++)for(var r=0;r<4;r++){var s=0;for(var k=0;k<4;k++)s+=A[k*4+r]*B[c*4+k];R[c*4+r]=s;} return R; }
        function ident(){ return [1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1]; }
        function trs(t,q,s){ var x=q[0],y=q[1],z=q[2],w=q[3],xx=x*x,yy=y*y,zz=z*z,xy=x*y,xz=x*z,yz=y*z,wx=w*x,wy=w*y,wz=w*z;
          return [(1-2*(yy+zz))*s[0],(2*(xy+wz))*s[0],(2*(xz-wy))*s[0],0,(2*(xy-wz))*s[1],(1-2*(xx+zz))*s[1],(2*(yz+wx))*s[1],0,(2*(xz+wy))*s[2],(2*(yz-wx))*s[2],(1-2*(xx+yy))*s[2],0,t[0],t[1],t[2],1]; }
        function nlocal(n){ return n.matrix ? n.matrix.slice() : trs(n.translation||[0,0,0], n.rotation||[0,0,0,1], n.scale||[1,1,1]); }
        function ap(M,v){ return [M[0]*v[0]+M[4]*v[1]+M[8]*v[2]+M[12], M[1]*v[0]+M[5]*v[1]+M[9]*v[2]+M[13], M[2]*v[0]+M[6]*v[1]+M[10]*v[2]+M[14]]; }
        function apd(M,v){ return [M[0]*v[0]+M[4]*v[1]+M[8]*v[2], M[1]*v[0]+M[5]*v[1]+M[9]*v[2], M[2]*v[0]+M[6]*v[1]+M[10]*v[2]]; }
        function nz(v){ var l=Math.hypot(v[0],v[1],v[2])||1; return [v[0]/l,v[1]/l,v[2]/l]; }
        var world = {};
        (function walk(list, par){ list.forEach(function(ni){ var M=mmul(par,nlocal(gltf.nodes[ni])); world[ni]=M; if(gltf.nodes[ni].children) walk(gltf.nodes[ni].children, M); }); })(gltf.scenes[gltf.scene||0].nodes, ident());
        var meshNodes = {};
        gltf.nodes.forEach(function(n,ni){ if(n.mesh!=null){ (meshNodes[n.mesh]=meshNodes[n.mesh]||[]).push(ni); } });
        var mn=[1e9,1e9,1e9], mx=[-1e9,-1e9,-1e9], plates=[];
        gltf.meshes.forEach(function(mesh,mi){ (meshNodes[mi]||[]).forEach(function(ni){ var M=world[ni]; mesh.primitives.forEach(function(pr){
          var poss = acc(pr.attributes.POSITION).map(function(p){ return ap(M,p); });
          poss.forEach(function(w){ for(var i=0;i<3;i++){ if(w[i]<mn[i])mn[i]=w[i]; if(w[i]>mx[i])mx[i]=w[i]; } });
          var mat = (pr.material!=null && gltf.materials[pr.material]) ? gltf.materials[pr.material].name : '';
          if (!mat || mat.indexOf('WT_Gravur')!==0) return;
          var nrm=[0,0,0]; if(pr.attributes.NORMAL!=null){ acc(pr.attributes.NORMAL).forEach(function(n){ var w=nz(apd(M,n)); nrm[0]+=w[0];nrm[1]+=w[1];nrm[2]+=w[2]; }); }
          var N=nz(nrm), c=[0,0,0]; poss.forEach(function(p){ c[0]+=p[0];c[1]+=p[1];c[2]+=p[2]; }); c=[c[0]/poss.length,c[1]/poss.length,c[2]/poss.length];
          plates.push({ mat:mat, cx:c[0], N:N, c:c });
        }); }); });
        if (!plates.length) { cb(null); return; }
        var diag = Math.hypot(mx[0]-mn[0],mx[1]-mn[1],mx[2]-mn[2]);
        var radius = Math.round(diag*0.65*1000)/1000;   // etwas weiter weg vom Modell
        plates.sort(function(a,b){ return a.cx-b.cx; });
        var labels = plates.length===3 ? ['Position A','Position B','Position C'] : null;
        cb(plates.map(function(p,i){
          var theta = Math.atan2(p.N[0],p.N[2])*180/Math.PI;
          var phi = Math.acos(Math.max(-1,Math.min(1,p.N[1])))*180/Math.PI; if(phi<6) phi=8;
          return { l: labels ? labels[i] : ('Stelle '+(i+1)), m: p.mat,
                   o: theta.toFixed(1)+'deg '+phi.toFixed(1)+'deg '+radius+'m',
                   t: p.c[0].toFixed(3)+'m '+p.c[1].toFixed(3)+'m '+p.c[2].toFixed(3)+'m' };
        }));
      } catch (e) { cb(null); }
    }).catch(function(){ cb(null); });
  }

  var pdp = document.querySelector('[data-ws-pdp]');
  if (!pdp) return;
  var ctl = pdp.querySelector('[data-e3d-controls]');
  var row = ctl && ctl.querySelector('[data-e3d-row]');
  var mvWrap = pdp.querySelector('[data-ws-mv-wrap]');
  var mv = mvWrap ? mvWrap.querySelector('model-viewer') : null;
  var url = mv && mv.getAttribute('src');
  if (!ctl || !row || !mv || !url) return;

  var gallery = pdp.querySelector('.ws-pdp__gallery');
  var engBlock = pdp.querySelector('[data-ws-engrave]');   // ganzer Personalisierungs-Block (startet display:none)
  var nameEl  = pdp.querySelector('[data-ws-engrave-input]');
  var figBtns = [].slice.call(pdp.querySelectorAll('[data-ws-fig]'));
  var optBtns = [].slice.call(pdp.querySelectorAll('[data-ws-opt]'));
  var BURN = '#3c2816';

  // Nur Deutsch/Englisch zulassen: lateinische Buchstaben + Umlaute/ß, Ziffern,
  // Leerzeichen und einfache Satzzeichen. Kyrillisch o. a. wird beim Tippen entfernt.
  var GRAVUR_ALLOW = /[^A-Za-z0-9ÄÖÜäöüß \-'.,&]/g;
  if (nameEl) nameEl.addEventListener('input', function () {
    var v = nameEl.value, clean = v.replace(GRAVUR_ALLOW, '');
    if (clean !== v) { var pos = (nameEl.selectionStart || v.length) - (v.length - clean.length); nameEl.value = clean; try { nameEl.setSelectionRange(pos, pos); } catch (e) {} }
  });

  var preset = null, posBtns = [], pos = 0, matByName = null, currentTex = null, ready = false;
  var stickyTop = 12;                                   // wird an die Sticky-Kopfzeile angepasst

  mv.setAttribute('camera-controls', '');
  mv.setAttribute('min-camera-orbit', 'auto auto 0.1m');
  mv.setAttribute('max-camera-orbit', 'auto auto 3m');

  function maybeShow(){ if (preset && ready) ctl.hidden = false; }
  function revealPerso(){ if (engBlock) engBlock.style.display = 'flex'; }   // nur bei Modellen mit WT_Gravur-Platten
  function posLabel(i){ return preset && preset[i] ? preset[i].l : ''; }
  function optOn(key){ var b = pdp.querySelector('[data-ws-opt="'+key+'"]'); return !!(b && b.classList.contains('is-on')); }
  function curFigSvg(){ var b = pdp.querySelector('[data-ws-fig].is-on'); var s = b && b.querySelector('svg'); return s ? s.outerHTML : ''; }
  function hide(m){ try { m.pbrMetallicRoughness.baseColorTexture.setTexture(null); } catch(e){} try { m.pbrMetallicRoughness.setBaseColorFactor([1,1,1,0]); } catch(e){} }
  function show(m){ try { m.pbrMetallicRoughness.setBaseColorFactor([1,1,1,1]); } catch(e){} }
  function tint(svg){
    if (!svg) return '';
    svg = svg.replace(/stroke="[^"]*"/g,'stroke="'+BURN+'"').replace(/fill="(?!none)[^"]*"/g,'fill="'+BURN+'"');
    var a=''; if(!/<svg[^>]*\swidth=/i.test(svg)) a+=' width="256" height="256"'; if(!/<svg[^>]*\sfill=/i.test(svg)) a+=' fill="'+BURN+'"';
    if (a) svg = svg.replace(/<svg/i, '<svg'+a);
    return svg;
  }
  function drawSpaced(ctx, text, cx, cy, size, sp){
    if (!text) return;
    ctx.font = '400 ' + size + 'px Jua, "Schibsted Grotesk", sans-serif';
    var ch = text.split(''), w = ch.map(function(c){ return ctx.measureText(c).width; });
    var tot = w.reduce(function(a,b){return a+b;},0) + sp*(ch.length-1), x = cx - tot/2;
    ctx.textAlign='left'; ctx.textBaseline='middle';
    for (var i=0;i<ch.length;i++){ ctx.fillText(ch[i], x, cy); x += w[i] + sp; }
  }
  /* ab dem 6. Zeichen schrumpft der Text, sodass die Breite = Breite der ersten 5 Zeichen bleibt */
  function fitText(ctx, name, size, sp){
    if (name.length > 5){
      ctx.font = '400 ' + size + 'px Jua, "Schibsted Grotesk", sans-serif';
      function wid(str){ var t=0; for(var i=0;i<str.length;i++){ t += ctx.measureText(str[i]).width; } return t + sp*Math.max(0,str.length-1); }
      var full = wid(name), five = wid(name.slice(0,5)), scale = full>0 ? five/full : 1;
      size *= scale; sp *= scale;
    }
    return { size: size, sp: sp };
  }
  var engraveDefaultEl = pdp.querySelector('[data-ws-engrave-out]');
  var engraveDefaultText = engraveDefaultEl ? (engraveDefaultEl.getAttribute('data-default') || '') : '';
  function buildCanvas(cb){
    // Same fallback the flat wood-plank preview uses (data-ws-engrave-out's
    // data-default) - so the 3D-engraved plate isn't blank the instant the
    // toggle switches on, before the shopper has typed a real name.
    var typed = nameEl ? nameEl.value : '';
    var name = (optOn('engrave') ? (typed || engraveDefaultText) : '').toUpperCase();
    var figSvg = optOn('figure') ? curFigSvg() : '';
    var S = 1024, BASE = 280, c = document.createElement('canvas'); c.width = S; c.height = S;   // BASE gross -> fast randfuellend
    var ctx = c.getContext('2d'); ctx.clearRect(0,0,S,S); ctx.fillStyle = BURN;
    function drawName(){
      var y;
      if (figSvg){ y = S*0.78; if (name.length > 5) y -= (name.length-5)*S*0.018; }
      else { y = S*0.52; }
      (document.fonts && document.fonts.load ? document.fonts.load('400 '+BASE+'px Jua') : Promise.resolve()).then(function(){
        var f = fitText(ctx, name, BASE, BASE*0.10);
        drawSpaced(ctx, name, S/2, y, f.size, f.sp); cb(c.toDataURL('image/png'), (name||figSvg));
      });
    }
    if (figSvg){
      var img = new Image();
      img.onload = function(){ var sz = S*0.56; var fy = name ? S*0.03 : (S-sz)/2; ctx.drawImage(img,(S-sz)/2,fy,sz,sz); drawName(); };   // mit Name: Figur oben; ohne Name: mittig
      img.onerror = drawName;
      img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(tint(figSvg));
    } else drawName();
  }
  var bakeTimer = null;
  function bake(delay){
    clearTimeout(bakeTimer);
    bakeTimer = setTimeout(function(){
      if (!ready || !preset) return;
      buildCanvas(function(u, hasContent){
        if (!hasContent){ currentTex = null; apply(); return; }
        mv.createTexture(u).then(function(t){ currentTex = t; apply(); });
      });
    }, delay == null ? 320 : delay);
  }
  function apply(){
    if (!ready || !matByName || !preset) return;
    for (var n in matByName) hide(matByName[n]);
    var am = matByName[preset[pos].m];
    if (am && currentTex){ try { am.pbrMetallicRoughness.baseColorTexture.setTexture(currentTex); } catch(e){} show(am); }
  }
  function moveCameraTo(i){ var p = preset && preset[i]; if (!p) return; try { mv.cameraOrbit = p.o; } catch(e){} try { mv.cameraTarget = p.t; } catch(e){} }
  function stopSpin(){ mv.dataset.engraveActive = '1'; mv.removeAttribute('auto-rotate'); }
  function showModel(){
    if (!gallery) return;
    pdp.classList.add('is-engrave');
    document.documentElement.classList.add('ws-e3d-live');
    stopSpin();
    gallery.classList.add('is-model');
    pdp.querySelectorAll('[data-ws-view]').forEach(function(v){ v.classList.toggle('is-on', v.getAttribute('data-ws-view')==='model'); });
    pdp.querySelectorAll('[data-ws-view-btn]').forEach(function(b){ b.classList.toggle('is-on', b.getAttribute('data-ws-view-btn')==='model'); });
    var t3 = pdp.querySelector('[data-ws-3d-toggle]');
    if (t3){ t3.classList.add('is-on'); var l = t3.querySelector('[data-lbl]'); if (l) l.textContent = t3.getAttribute('data-lbl-off') || 'Fotos'; }
    updateStuck();
  }
  function recalcTop(){                                 // Vorschau haengt UNTER der Sticky-Kopfzeile
    var h = document.querySelector('.ws-header');
    var hh = h ? Math.round(h.getBoundingClientRect().height) : 0;
    stickyTop = (hh || 4) + 8;
    pdp.style.setProperty('--e3d-sticky-top', stickyTop + 'px');
  }
  function updateStuck(){
    if (!gallery) return;
    if (!pdp.classList.contains('is-engrave')) { pdp.classList.remove('is-stuck'); return; }
    pdp.classList.toggle('is-stuck', gallery.getBoundingClientRect().top <= stickyTop + 3);
  }

  mv.addEventListener('load', function () {
    try {
      matByName = {};
      (mv.model ? mv.model.materials : []).forEach(function (m) {
        if (m.name && m.name.indexOf('WT_Gravur') === 0) { matByName[m.name] = m; try { m._wtFactor = (m.pbrMetallicRoughness.baseColorFactor || [1,1,1,1]).slice(); } catch(e){ m._wtFactor = [1,1,1,1]; } try { m.setAlphaMode('BLEND'); } catch(e){} hide(m); }
      });
      if (!Object.keys(matByName).length) return;
      // Modell hat Gravur-Platten -> statisches USDZ (mit "123/NAME"-Platzhalter)
      // nicht verwenden; iOS erzeugt AR live aus der bereinigten Szene.
      try { mv.removeAttribute('ios-src'); } catch(e){}
      revealPerso();
      ready = true; maybeShow(); bake(0);
    } catch (e) {}
  });

  // Gravur-Platten für AR säubern: Textur weg (kein "123/NAME"-Platzhalter, keine
  // Live-Gravur) und opak (keine Transparenz). Wird VOR activateAR aufgerufen.
  mv._wtArClean = function () {
    if (!matByName) return;
    for (var n in matByName) { var m = matByName[n];
      try { m.pbrMetallicRoughness.baseColorTexture.setTexture(null); } catch(x){}
      try { m.setAlphaMode('OPAQUE'); } catch(x){}
      try { m.pbrMetallicRoughness.setBaseColorFactor(m._wtFactor || [1,1,1,1]); } catch(x){}
    }
  };
  // Nach AR-Ende die Live-Gravur wiederherstellen.
  mv.addEventListener('ar-status', function (e) {
    if (!matByName) return;
    var st = e.detail && e.detail.status;
    if (st === 'session-started') {
      mv._wtArClean();
    } else if (st === 'not-presenting') {
      for (var k in matByName) { try { matByName[k].setAlphaMode('BLEND'); } catch(x){} }
      apply();
    }
  });

  computePresets(url, function (ps) {
    if (!ps || !ps.length) return;                       // Produkt ohne Gravur-Platten -> Feature aus
    preset = ps;
    revealPerso();
    ps.forEach(function (p, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'ws-e3dctl__btn' + (i === 0 ? ' is-on' : '');
      b.setAttribute('data-e3d-pos', i); b.textContent = p.l; row.appendChild(b);
    });
    posBtns = [].slice.call(row.querySelectorAll('[data-e3d-pos]'));
    pdp.setAttribute('data-engrave-pos', posLabel(0));

    if (gallery) {
      var minBtn = document.createElement('button');
      minBtn.type = 'button'; minBtn.className = 'ws-e3d-min';
      minBtn.setAttribute('aria-label', '3D-Vorschau ein- oder ausklappen');
      minBtn.innerHTML = '<svg class="ws-e3d-min__chev" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 15l6-6 6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>3D-Vorschau</span>';
      gallery.appendChild(minBtn);
      minBtn.addEventListener('click', function () { pdp.classList.toggle('is-collapsed'); });
    }

    nameEl && nameEl.addEventListener('input', function(){ if (nameEl.value && optOn('engrave')) showModel(); bake(); });
    figBtns.forEach(function(btn){ btn.addEventListener('click', function(){ showModel(); bake(0); }); });
    optBtns.forEach(function(btn){ btn.addEventListener('click', function(){
      var turnedOn = btn.classList.contains('is-on');
      if (optOn('engrave') || optOn('figure')) {
        showModel();
        // beim Einschalten sofort in den 3D-Modus mit Position A (Standard)
        if (turnedOn && preset && preset.length) {
          pos = 0;
          posBtns.forEach(function(b, i){ b.classList.toggle('is-on', i === 0); });
          pdp.setAttribute('data-engrave-pos', posLabel(0));
          stopSpin(); moveCameraTo(0);
        }
      }
      else { pdp.classList.remove('is-engrave'); document.documentElement.classList.remove('ws-e3d-live'); }
      bake(0);
    }); });
    posBtns.forEach(function(btn){ btn.addEventListener('click', function(){
      posBtns.forEach(function(b){ b.classList.remove('is-on'); }); btn.classList.add('is-on');
      pos = parseInt(btn.getAttribute('data-e3d-pos'),10) || 0;
      pdp.setAttribute('data-engrave-pos', posLabel(pos));
      stopSpin(); moveCameraTo(pos); bake(0);
    }); });

    var stuckRAF = 0;
    window.addEventListener('scroll', function(){ if (stuckRAF) return; stuckRAF = requestAnimationFrame(function(){ stuckRAF = 0; updateStuck(); }); }, { passive: true });
    window.addEventListener('resize', function(){ recalcTop(); updateStuck(); });

    recalcTop();
    maybeShow(); bake(0);
  });
})();
